// extracted by mini-css-extract-plugin
export default {"tabContainer":"TabContainer_tabContainer__QDXCv","hide":"TabContainer_hide__y72EE"};